import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  src: "https://placehold.jp/b8b8b8/ffffff/320x180.jpg?text=写真"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 総額：")
const _hoisted_3 = {
  class: "text-red text-bold",
  style: {"font-size":"1.6em"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("円 ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "q-ma-md text-center" }
const _hoisted_7 = { class: "text-center" }

import { ref } from 'vue'
import { useAsyncTask } from 'vue-concurrency'
import api from '@/estimate/api'
import { JocarCarList } from '@/estimate/models'

/** 中古車情報一覧 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const usedCarList = ref<JocarCarList['stock_info']>([])

/** 中古車情報一覧取得タスク */
const getUsedCarListTask = useAsyncTask(async () => {
  return api.external.jocarCarList({ HNCD: '000001', HIT_PER_PAGE: 8 }).then(res => {
    usedCarList.value = res.stock_info
  })
})

getUsedCarListTask.perform()

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.root)
  }, [
    _createElementVNode("h2", {
      class: _normalizeClass(_ctx.$style.heading)
    }, "中古車情報", 2),
    _createElementVNode("ul", {
      class: _normalizeClass(_ctx.$style.list)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usedCarList.value, (data) => {
        return (_openBlock(), _createElementBlock("li", {
          key: data.stock_number,
          class: _normalizeClass(_ctx.$style.item)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.image)
          }, [
            (data.img.length > 0)
              ? (_openBlock(), _createBlock(_component_q_img, {
                  key: 0,
                  src: data.img[0].img_url,
                  ratio: 4 / 3
                }, null, 8, ["src"]))
              : (_openBlock(), _createElementBlock("img", _hoisted_1))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.$style.carName, "q-mb-xs"])
          }, _toDisplayString(data.maker) + " " + _toDisplayString(data.car_name), 3),
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.$style.price, "text-right"])
          }, [
            _hoisted_2,
            _createElementVNode("span", _hoisted_3, _toDisplayString(data.price_total), 1),
            _hoisted_4
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.$style.otherInfo, "q-mb-xs"])
          }, [
            _createTextVNode(" 年式：" + _toDisplayString(data.year_jpn), 1),
            _hoisted_5,
            _createTextVNode(" 走行距離：" + _toDisplayString(data.distance), 1)
          ], 2),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_q_btn, {
              unelevated: "",
              rounded: "",
              color: "brand",
              label: "詳しく見る",
              type: "a",
              href: `https://showa-metal.jp/buycar/detail.html?GM=${data.stock_number}`
            }, null, 8, ["href"])
          ])
        ], 2))
      }), 128))
    ], 2),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_q_btn, {
        unelevated: "",
        label: "中古車情報一覧を見る",
        color: "brand",
        size: "lg",
        type: "a",
        href: "https://showa-metal.jp/buycar/"
      })
    ])
  ], 2))
}
}

})